'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _draftJs = require('draft-js');

var _makerActions = require('../../actions/makerActions');

var _EditorControls = require('./EditorControls');

var _EditorControls2 = _interopRequireDefault(_EditorControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditor = function (_React$Component) {
	_inherits(TextEditor, _React$Component);

	function TextEditor(props) {
		_classCallCheck(this, TextEditor);

		var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));

		var _this$props = _this.props,
		    editorState = _this$props.editorState,
		    data = _this$props.data;

		var rawData = (typeof editorState === 'undefined' ? 'undefined' : _typeof(editorState)) !== undefined ? editorState : data;

		_this.state = {
			editorState: _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(rawData))
		};

		_this.focus = function () {
			return _this.refs.editor.focus();
		};

		_this.onChange = function (editorState, focus) {

			_this.props.dispatch((0, _makerActions.updateComponent)(_this.props.componentIndex, _extends({}, _this.props.component, {
				editorState: (0, _draftJs.convertToRaw)(editorState.getCurrentContent())
			})));

			_this.setState({ editorState: editorState }, function () {
				if (focus) {
					_this.focus();
				}
			});
		};

		_this.handleKeyCommand = function (command) {
			return _this._handleKeyCommand(command);
		};
		_this.onTab = function (e) {
			return _this._onTab(e);
		};
		_this.toggleBlockType = function (type) {
			return _this._toggleBlockType(type);
		};
		_this.toggleInlineStyle = function (style) {
			return _this._toggleInlineStyle(style);
		};
		return _this;
	}

	_createClass(TextEditor, [{
		key: '_handleKeyCommand',
		value: function _handleKeyCommand(command) {
			var newState = _draftJs.RichUtils.handleKeyCommand(this.state.editorState, command);
			if (newState) {
				this.onChange(newState);
				return true;
			}
			return false;
		}
	}, {
		key: '_onTab',
		value: function _onTab(e) {
			var maxDepth = 4;
			this.onChange(_draftJs.RichUtils.onTab(e, this.state.editorState, maxDepth));
		}
	}, {
		key: '_toggleBlockType',
		value: function _toggleBlockType(type) {
			this.onChange(_draftJs.RichUtils.toggleBlockType(this.state.editorState, type), true);
		}
	}, {
		key: '_toggleInlineStyle',
		value: function _toggleInlineStyle(style) {
			this.onChange(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, style), true);
		}
	}, {
		key: 'render',
		value: function render() {
			var editorState = this.state.editorState;


			var className = 'RichEditor-editor';
			var contentState = editorState.getCurrentContent();
			if (!contentState.hasText()) {
				if (contentState.getBlockMap().first().getType() !== 'unstyled') {
					className += ' RichEditor-hidePlaceholder';
				}
			}

			return _react2.default.createElement(
				'div',
				{ className: 'RichEditor-root' },
				_react2.default.createElement(_EditorControls2.default, {
					editorState: editorState,
					toggleInlineStyle: this.toggleInlineStyle,
					toggleBlockType: this.toggleBlockType
				}),
				_react2.default.createElement(
					'div',
					{ className: className, onClick: this.focus },
					_react2.default.createElement(_draftJs.Editor, {
						editorState: editorState,
						handleKeyCommand: this.handleKeyCommand,
						onChange: this.onChange,
						onTab: this.onTab,
						placeholder: 'Start writing here...',
						ref: 'editor'
					})
				)
			);
		}
	}]);

	return TextEditor;
}(_react2.default.Component);

TextEditor = (0, _reactRedux.connect)()(TextEditor);

exports.default = TextEditor;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/TextEditor.js
// module id = 582
// module chunks = 0